/**
 * @generated SignedSource<<0ee5dead137d699ee0a506952900e64e>>
 * @relayHash dc6f16a1903a9b935e38c03cb306e511
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83754c417fd18ea71880604b73be90fcde4942135706d12deec003b4f40fb01d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type editionAwarenessQuery$variables = {
  cloudId: string;
  productKey: string;
  shouldCheckForFree: boolean;
  shouldCheckForTrial: boolean;
  shouldSkip: boolean;
};
export type editionAwarenessQuery$data = {
  readonly tenantContexts?: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly freeEntitlement?: {
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly trialEntitlement?: {
        readonly preDunning?: {
          readonly status: CcpEntitlementPreDunningStatus | null | undefined;
        } | null | undefined;
        readonly subscription: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePaymentV2: {
                  readonly isAvailableToUser: boolean | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly invoiceable: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly trial: {
            readonly endTimestamp: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type editionAwarenessQuery = {
  response: editionAwarenessQuery$data;
  variables: editionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldCheckForFree"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldCheckForTrial"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldSkip"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Standard"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v5 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v6 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "AND": [
        {
          "inTrialOrPreDunning": true
        }
      ]
    }
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "status"
},
v8 = {
  "kind": "ScalarField",
  "name": "endTimestamp"
},
v9 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = [
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "editionAwarenessQuery",
    "selections": [
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  {
                    "condition": "shouldCheckForFree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "freeEntitlement",
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "experienceCapabilities",
                            "plural": false,
                            "selections": [
                              {
                                "args": (v3/*: any*/),
                                "kind": "LinkedField",
                                "name": "changeOfferingV2",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldCheckForTrial",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "trialEntitlement",
                        "args": (v6/*: any*/),
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "shouldCheckForTrial",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "preDunning",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "experienceCapabilities",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "configurePaymentV2",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "editionAwarenessQuery",
    "selections": [
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "condition": "shouldCheckForFree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "freeEntitlement",
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "experienceCapabilities",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "args": (v3/*: any*/),
                                "kind": "LinkedField",
                                "name": "changeOfferingV2",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                              }
                            ]
                          },
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldCheckForTrial",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "trialEntitlement",
                        "args": (v6/*: any*/),
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "condition": "shouldCheckForTrial",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "preDunning",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v8/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v9/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "experienceCapabilities",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "configurePaymentV2",
                                            "plural": false,
                                            "selections": [
                                              (v10/*: any*/),
                                              (v4/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v12/*: any*/),
                                        "type": "CcpInvoiceGroup"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v12/*: any*/),
                                "type": "CcpSubscription"
                              }
                            ]
                          },
                          (v11/*: any*/)
                        ],
                        "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "83754c417fd18ea71880604b73be90fcde4942135706d12deec003b4f40fb01d",
    "metadata": {},
    "name": "editionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d91de48c6ded4eb542b1479b76bd61e8";

export default node;
